import { Grid, Tooltip } from "@material-ui/core";
import { Timer } from "@material-ui/icons";
import IconDelete from "app/common/Icon/IconDelete";
import IconEye from "app/common/Icon/IconEye";
import IconPen from "app/common/Icon/IconPen";
import LightGallary from "app/common/LightGallary";
import { STATUS_PATIENT_ADVISE } from "app/common/LocalConst";
import {
  dateTime,
  getCurrentStaff,
  isAdmin,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import SuggestionPrice from "./Component/SuggestionPrice";

const ChatBoxAdviseContent = ({
  items,
  handleEdit,
  handleDelete,
  // isDeletePermission,
  // isEditPermission,
  handleSaveItemAdvise,
}) => {
  const [hoveredMessageId, setHoveredMessageId] = useState(null);
  const [showHistory, setShowHistory] = useState(null);
  const currentStaff = getCurrentStaff();
  const { setFieldValue, submitForm, values } = useFormikContext();

  let formatItem = (item) => {
    // handleGetItemById(item?.id);
    let {
      customerConfirmedServices,
      customerInterestedServices,
      customerInterestedProducts,
      customerConfirmedProducts,
      customerInterestedPrepaidCards,
      customerConfirmedPrepaidCards,
      customerInterestedTreatmentCards,
      customerConfirmedTreatmentCards,
    } = item;

    if (customerConfirmedServices?.length > 0) {
      item.customerConfirmedServices = customerConfirmedServices?.map((el) => {
        if (el?.service)
          return {
            ...el.service,
            paiPrice: el?.price,
            paiPatientTypeService: el?.patientTypeService,
          };
        else return el;
      });
    }
    if (customerInterestedServices?.length > 0) {
      item.customerInterestedServices = customerInterestedServices?.map(
        (el) => {
          if (el?.service) return el.service;
          else return el;
        }
      );
    }

    if (customerInterestedProducts?.length > 0) {
      item.customerInterestedProducts = customerInterestedProducts?.map(
        (el) => {
          if (el?.drug) return el.drug;
          else return el;
        }
      );
    }
    if (customerConfirmedProducts?.length > 0) {
      item.customerConfirmedProducts = customerConfirmedProducts?.map((el) => {
        if (el?.drug) {
          return {
            ...el.drug,
            paiPrice: el?.price,
            paiPatientTypeService: el?.patientTypeService,
          };
        } else return el;
      });
    }

    if (customerInterestedPrepaidCards?.length > 0) {
      item.customerInterestedPrepaidCards = customerInterestedPrepaidCards?.map(
        (el) => {
          if (el?.clientCard) return el.clientCard;
          else return el;
        }
      );
    }
    if (customerConfirmedPrepaidCards?.length > 0) {
      item.customerConfirmedPrepaidCards = customerConfirmedPrepaidCards?.map(
        (el) => {
          if (el?.clientCard) {
            return {
              ...el.clientCard,
              paiPrice: el?.price,
              paiPatientTypeService: el?.patientTypeService,
            };
          } else return el;
        }
      );
    }

    if (customerInterestedTreatmentCards?.length > 0) {
      item.customerInterestedTreatmentCards =
        customerInterestedTreatmentCards?.map((el) => {
          if (el?.clientCard) return el.clientCard;
          else return el;
        });
    }
    if (customerConfirmedTreatmentCards?.length > 0) {
      item.customerConfirmedTreatmentCards =
        customerConfirmedTreatmentCards?.map((el) => {
          if (el?.clientCard) {
            return {
              ...el.clientCard,
              paiPrice: el?.price,
              paiPatientTypeService: el?.patientTypeService,
            };
          } else return el;
        });
    }
    return item;
  };
  return (
    <>
      {items
        ?.slice()
        ?.reverse()
        ?.map((item, index) => {
          const originalIndex = items.length - 1 - index;
          let isCurrent = currentStaff?.id === item?.staff?.id;
          let isInterestedServices =
            item?.customerInterestedServices == null ||
            item?.customerInterestedServices?.length === 0;
          let isConfirmedServices =
            item?.customerConfirmedServices == null ||
            item?.customerConfirmedServices?.length === 0;

          let isInterestedProducts =
            item?.customerInterestedProducts == null ||
            item?.customerInterestedProducts?.length === 0;
          let isConfirmedProducts =
            item?.customerConfirmedProducts == null ||
            item?.customerConfirmedProducts?.length === 0;

          let isInterestedPrepaidCards =
            item?.customerInterestedPrepaidCards == null ||
            item?.customerInterestedPrepaidCards?.length === 0;
          let isConfirmedPrepaidCards =
            item?.customerConfirmedPrepaidCards == null ||
            item?.customerConfirmedPrepaidCards?.length === 0;
          let isInterestedTreatmentCards =
            item?.customerInterestedTreatmentCards == null ||
            item?.customerInterestedTreatmentCards?.length === 0;
          let isConfirmedTreatmentCards =
            item?.customerConfirmedTreatmentCards == null ||
            item?.customerConfirmedTreatmentCards?.length === 0;

          return (
            <>
              <div>
                <Grid
                  className={`group-info-customer ${isCurrent && "align-end"}`}
                  container
                >
                  {index === 0 ||
                  items?.[index - 1]?.staff?.id !== item?.staff?.id ? (
                    <Grid item xs={12} className="info mt-3">
                      <div
                        className={`flex align-center title-name ${
                          isCurrent && "justify-end"
                        }`}
                      >
                        <p className="user-img">
                          <svg viewBox="0 0 143 143" fill="none">
                            <path
                              d="M126.253 116.987C133.568 108.185 138.656 97.7514 141.086 86.5678C143.516 75.3841 143.216 63.7798 140.213 52.7363C137.21 41.6928 131.591 31.5351 123.831 23.1225C116.072 14.71 106.401 8.28994 95.6356 4.4056C84.8703 0.521257 73.3279 -0.713138 61.9847 0.806837C50.6415 2.32681 39.8312 6.55644 30.4684 13.1379C21.1056 19.7194 13.4656 28.4591 8.19484 38.6177C2.92405 48.7763 0.177503 60.055 0.187527 71.4995C0.191374 88.1367 6.05423 104.241 16.7473 116.987L16.6454 117.073C17.002 117.501 17.4095 117.868 17.7762 118.291C18.2347 118.815 18.7288 119.309 19.2025 119.819C20.6287 121.367 22.0957 122.855 23.6341 124.25C24.1027 124.678 24.5866 125.076 25.0603 125.483C26.6903 126.889 28.3662 128.224 30.1031 129.466C30.3272 129.619 30.531 129.818 30.7551 129.976V129.915C42.6852 138.31 56.9171 142.816 71.5051 142.816C86.0931 142.816 100.325 138.31 112.255 129.915V129.976C112.479 129.818 112.678 129.619 112.907 129.466C114.639 128.218 116.32 126.889 117.95 125.483C118.424 125.076 118.908 124.673 119.376 124.25C120.914 122.85 122.381 121.367 123.808 119.819C124.281 119.309 124.77 118.815 125.234 118.291C125.596 117.868 126.008 117.501 126.365 117.068L126.253 116.987ZM71.5 30.7495C76.0335 30.7495 80.4653 32.0939 84.2347 34.6126C88.0042 37.1313 90.9422 40.7112 92.6771 44.8996C94.412 49.088 94.8659 53.6968 93.9815 58.1432C93.097 62.5897 90.9139 66.6739 87.7082 69.8796C84.5026 73.0853 80.4183 75.2684 75.9719 76.1528C71.5255 77.0373 66.9166 76.5834 62.7282 74.8485C58.5398 73.1135 54.9599 70.1756 52.4412 66.4061C49.9225 62.6366 48.5782 58.2049 48.5782 53.6714C48.5782 47.5921 50.9931 41.7619 55.2918 37.4632C59.5905 33.1645 65.4208 30.7495 71.5 30.7495ZM30.7857 116.987C30.874 110.298 33.5921 103.914 38.3517 99.2143C43.1114 94.5147 49.5299 91.878 56.2188 91.8745H86.7813C93.4701 91.878 99.8887 94.5147 104.648 99.2143C109.408 103.914 112.126 110.298 112.214 116.987C101.043 127.054 86.5381 132.625 71.5 132.625C56.462 132.625 41.9571 127.054 30.7857 116.987Z"
                              fill="#9A9A9A"
                            />
                          </svg>
                        </p>

                        <span className="info-name">
                          {item?.staff?.staffName || "ADMIN"}
                        </span>
                      </div>

                      <div className={`text-danger timer flex align-center`}>
                        <span className="flex align-center">
                          <Timer style={{ fontSize: "10px" }} />
                        </span>
                        <strong>{dateTime(item?.modifyDate) || ""}</strong>
                      </div>
                    </Grid>
                  ) : (
                    <>
                      <Grid item xs={12} className="info ">
                        <div className={`text-danger timer flex align-center`}>
                          <span className="flex align-center">
                            <Timer style={{ fontSize: "10px" }} />
                          </span>
                          <strong>{dateTime(item?.modifyDate) || ""}</strong>
                        </div>
                      </Grid>
                    </>
                  )}
                  <Grid
                    item
                    xs={12}
                    className={`gap-2 flex justify-end edit-history ${
                      !isCurrent && "row-reverse"
                    }  ${showHistory === index && "show"}`}
                  >
                    <div className="flex gap-1 justify-end">
                      {item?.lastContent && (
                        <span className={`chat color-primary opacity-7`}>
                          {item?.lastContent}
                        </span>
                      )}
                    </div>
                  </Grid>

                  {(item?.content || item?.internalContent) && (
                    <Grid
                      item
                      xs={12}
                      className={`gap-2 flex justify-end ${
                        !isCurrent && "row-reverse"
                      }`}
                      onMouseEnter={() => {
                        if (hoveredMessageId !== index) {
                          setHoveredMessageId(index);
                        }
                      }}
                      onMouseLeave={() => {
                        if (hoveredMessageId !== null) {
                          setHoveredMessageId(null);
                        }
                      }}
                    >
                      <div
                        className={`flex align-center gap-2 cursor ${
                          hoveredMessageId === index ? "invisible" : "unvisible"
                        }`}
                      >
                        <>
                          {item?.adviceItemStatus !==
                            STATUS_PATIENT_ADVISE[0].value && (
                            <Tooltip
                              title={`Lịch sử chỉnh sửa: ${item?.lastContent}`}
                            >
                              <div
                                className="flex font-sm"
                                onClick={() => {
                                  if (showHistory === index) {
                                    setShowHistory(null);
                                  } else {
                                    setShowHistory(index);
                                  }
                                }}
                              >
                                <IconEye />
                              </div>
                            </Tooltip>
                          )}
                          {item?.adviceItemStatus !==
                            STATUS_PATIENT_ADVISE[2].value && (
                            <>
                              <Tooltip title="Chỉnh sửa">
                                <div
                                  className="flex font-sm"
                                  onClick={() => {
                                    const itemFormat = formatItem(item);
                                    handleEdit(itemFormat);
                                  }}
                                >
                                  <IconPen />
                                </div>
                              </Tooltip>
                              <Tooltip title="Xóa tư vấn">
                                <div
                                  className="flex font-xs"
                                  onClick={() => {
                                    handleDelete(item);
                                  }}
                                >
                                  <IconDelete />
                                </div>
                              </Tooltip>
                            </>
                          )}
                        </>
                      </div>

                      {item?.adviceItemStatus ===
                      STATUS_PATIENT_ADVISE[2].value ? (
                        <>
                          <div className="flex gap-1 justify-end">
                            <span
                              className={`chat color-delete`}
                              style={{ fontSize: "13px" }}
                            >
                              <i>Tư vấn đã bị xóa</i>
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="flex gap-1 justify-end">
                            {item?.content && (
                              <span className={`chat color-primary`}>
                                {item?.content}
                              </span>
                            )}
                            {item?.internalContent && (
                              <span className={`chat color-note`}>
                                {item?.internalContent}
                              </span>
                            )}
                          </div>
                        </>
                      )}
                    </Grid>
                  )}

                  <Grid
                    item
                    xs={12}
                    className={`gap-2 flex mt-1 justify-end ${
                      !isCurrent && "row-reverse"
                    }`}
                    style={{ width: "100%" }}
                  >
                    <LightGallary>
                      {item?.convertLightGallary?.map((el, ind) => (
                        <a
                          key={ind}
                          href={el?.src}
                          data-src={el?.src}
                          data-sub-html={el?.alt || ""}
                          className="item-img-gallery"
                        >
                          <img src={el?.src} alt={el?.alt} />
                        </a>
                      ))}
                    </LightGallary>
                  </Grid>
                  {item?.adviceItemStatus ===
                    STATUS_PATIENT_ADVISE[1].value && (
                    <div className="flex gap-1 justify-end">
                      <span className={`font-xxs text-edit`}>
                        <i>Đã chỉnh sửa</i>
                      </span>
                    </div>
                  )}
                </Grid>
              </div>

              {!(isConfirmedServices && isInterestedServices) && (
                <>
                  <div className="service-groups">
                    <Tooltip title="Dịch vụ quan tâm">
                      <div
                        className={`service-group interested ${
                          isInterestedServices && "unvisible"
                        }`}
                      >
                        {!isInterestedServices && (
                          <div class="group-title">
                            <span class="tag tag-qt">DV</span>
                            <span class="title-text">Quan tâm</span>
                          </div>
                        )}
                        {item?.customerInterestedServices?.map((el, index) => (
                          <div className="service-item" key={index}>
                            {`${index + 1}. ${
                              el?.service?.name || el?.name
                            } - ${el?.service?.code || el?.code}`}
                          </div>
                        ))}
                      </div>
                    </Tooltip>
                    <Tooltip title="Dịch vụ đã chốt">
                      <>
                        <div
                          className={`service-group confirmed ${
                            isConfirmedServices && "unvisible"
                          }`}
                        >
                          {!isConfirmedServices && (
                            <div class="group-title">
                              <span class="tag tag-dc">DV</span>
                              <span class="title-text">Đã chốt</span>
                            </div>
                          )}
                          {item?.customerConfirmedServices?.map((el, ind) => (
                            <>
                              <div className="service-item" key={ind}>
                                {`${ind + 1}. ${
                                  el?.service?.name || el?.name
                                } - ${el?.service?.code || el?.code}`}
                              </div>

                              <>
                                <SuggestionPrice
                                  suggestedPrice={el?.service?.serviceFeeList}
                                  patientTypeServiceSelected={
                                    el?.patientTypeService
                                  }
                                  nameSpace={`patientAdvice.items[${originalIndex}].customerConfirmedServicesPrice[${ind}]`}
                                  onSelect={async (suggest) => {
                                    let newItemConfirmedService = {
                                      ...el,
                                      patientTypeService:
                                        suggest?.patientTypeService,
                                      price: suggest?.price,
                                    }; // phần tử mới

                                    let currCustomerConfirmedServices = [
                                      ...item?.customerConfirmedServices,
                                    ];

                                    currCustomerConfirmedServices[ind] =
                                      newItemConfirmedService;
                                    // xét phần tử mới vào mảng

                                    const itemFormat = formatItem({
                                      ...item,
                                      customerConfirmedServices:
                                        currCustomerConfirmedServices,
                                    });
                                    await handleSaveItemAdvise(itemFormat);
                                  }}
                                  handleBlurPrice={async (price) => {
                                    let newItemConfirmedService = {
                                      ...el,
                                      price,
                                    }; // phần tử mới

                                    let currCustomerConfirmedServices = [
                                      ...item?.customerConfirmedServices,
                                    ];

                                    currCustomerConfirmedServices[ind] =
                                      newItemConfirmedService;
                                    // xét phần tử mới vào mảng

                                    const itemFormat = formatItem({
                                      ...item,
                                      customerConfirmedServices:
                                        currCustomerConfirmedServices,
                                    });
                                    await handleSaveItemAdvise(itemFormat);
                                  }}
                                />
                              </>
                            </>
                          ))}
                        </div>
                      </>
                    </Tooltip>
                  </div>
                </>
              )}

              {!(isInterestedProducts && isConfirmedProducts) && (
                <>
                  <div className="service-groups">
                    <Tooltip title="Sản phẩm quan tâm">
                      <div
                        className={`service-group interested ${
                          isInterestedProducts && "unvisible"
                        }`}
                      >
                        {!isInterestedProducts && (
                          <div class="group-title">
                            <span class="tag tag-qt">SP</span>
                            <span class="title-text">Quan tâm</span>
                          </div>
                        )}
                        {item?.customerInterestedProducts?.map((el, index) => (
                          <div className="service-item" key={index}>
                            {`${index + 1}. ${el?.drug?.name || el?.name} - ${
                              el?.drug?.code || el?.code
                            }`}
                          </div>
                        ))}
                      </div>
                    </Tooltip>
                    <Tooltip title="Sản phẩm đã chốt">
                      <>
                        <div
                          className={`service-group confirmed ${
                            isConfirmedProducts && "unvisible"
                          }`}
                        >
                          {!isConfirmedProducts && (
                            <div class="group-title">
                              <span class="tag tag-dc">SP</span>
                              <span class="title-text">Đã chốt</span>
                            </div>
                          )}

                          {item?.customerConfirmedProducts?.map((el, ind) => (
                            <>
                              <div className="service-item" key={ind}>
                                {`${ind + 1}. ${el?.drug?.name || el?.name} - ${
                                  el?.drug?.code || el?.code
                                }`}
                              </div>

                              <>
                                <SuggestionPrice
                                  suggestedPrice={el?.drug?.drugUnitPrices}
                                  patientTypeServiceSelected={
                                    el?.patientTypeService
                                  }
                                  nameSpace={`patientAdvice.items[${originalIndex}].customerConfirmedProductsPrice[${ind}]`}
                                  onSelect={async (suggest) => {
                                    let newItemConfirmedProduct = {
                                      ...el,
                                      patientTypeService:
                                        suggest?.patientTypeService,
                                      price: suggest?.price,
                                    }; // phần tử mới

                                    let currCustomerConfirmedProducts = [
                                      ...item?.customerConfirmedProducts,
                                    ];

                                    currCustomerConfirmedProducts[ind] =
                                      newItemConfirmedProduct;
                                    // xét phần tử mới vào mảng

                                    const itemFormat = formatItem({
                                      ...item,
                                      customerConfirmedProducts:
                                        currCustomerConfirmedProducts,
                                    });
                                    await handleSaveItemAdvise(itemFormat);
                                  }}
                                  handleBlurPrice={async (price) => {
                                    let newItemConfirmedProduct = {
                                      ...el,
                                      price,
                                    }; // phần tử mới

                                    let currCustomerConfirmedProducts = [
                                      ...item?.customerConfirmedProducts,
                                    ];

                                    currCustomerConfirmedProducts[ind] =
                                      newItemConfirmedProduct;
                                    // xét phần tử mới vào mảng

                                    const itemFormat = formatItem({
                                      ...item,
                                      customerConfirmedProducts:
                                        currCustomerConfirmedProducts,
                                    });
                                    await handleSaveItemAdvise(itemFormat);
                                  }}
                                />
                              </>
                            </>
                          ))}
                        </div>
                      </>
                    </Tooltip>
                  </div>
                </>
              )}

              {!(isInterestedPrepaidCards && isConfirmedPrepaidCards) && (
                <>
                  <div className="service-groups">
                    <Tooltip title="Thẻ trả trước quan tâm">
                      <div
                        className={`service-group interested ${
                          isInterestedPrepaidCards && "unvisible"
                        }`}
                      >
                        {!isInterestedPrepaidCards && (
                          <div class="group-title">
                            <span class="tag tag-qt">THẺ</span>
                            <span class="title-text">Quan tâm</span>
                          </div>
                        )}
                        {item?.customerInterestedPrepaidCards?.map(
                          (el, index) => (
                            <div className="service-item" key={index}>
                              {`${index + 1}. ${
                                el?.clientCard?.name || el?.name
                              } - ${el?.clientCard?.code || el?.code}`}
                            </div>
                          )
                        )}
                      </div>
                    </Tooltip>
                    <Tooltip title="Thẻ trả trước đã chốt">
                      <>
                        <div
                          className={`service-group confirmed ${
                            isConfirmedPrepaidCards && "unvisible"
                          }`}
                        >
                          {!isConfirmedPrepaidCards && (
                            <div class="group-title">
                              <span class="tag tag-dc">THẺ</span>
                              <span class="title-text">Đã chốt</span>
                            </div>
                          )}

                          {item?.customerConfirmedPrepaidCards?.map(
                            (el, ind) => (
                              <>
                                <div className="service-item" key={ind}>
                                  {`${ind + 1}. ${
                                    el?.clientCard?.name || el?.name
                                  } - ${el?.clientCard?.code || el?.code}`}
                                </div>

                                <>
                                  <SuggestionPrice
                                    suggestedPrice={
                                      el?.clientCard?.clientCardFees
                                    }
                                    nameSpace={`patientAdvice.items[${originalIndex}].customerConfirmedPrepaidCardsPrice[${ind}]`}
                                    patientTypeServiceSelected={
                                      el?.patientTypeService
                                    }
                                    onSelect={async (suggest) => {
                                      let newItemConfirmedCard = {
                                        ...el,
                                        patientTypeService:
                                          suggest?.patientTypeService,
                                        price: suggest?.price,
                                      }; // phần tử mới

                                      let currCustomerConfirmedCards = [
                                        ...item?.customerConfirmedPrepaidCards,
                                      ];

                                      currCustomerConfirmedCards[ind] =
                                        newItemConfirmedCard;
                                      // xét phần tử mới vào mảng

                                      const itemFormat = formatItem({
                                        ...item,
                                        customerConfirmedPrepaidCards:
                                          currCustomerConfirmedCards,
                                      });
                                      await handleSaveItemAdvise(itemFormat);
                                    }}
                                    handleBlurPrice={async (price) => {
                                      let newItemConfirmedCard = {
                                        ...el,
                                        price,
                                      }; // phần tử mới

                                      let currCustomerConfirmedCards = [
                                        ...item?.customerConfirmedPrepaidCards,
                                      ];

                                      currCustomerConfirmedCards[ind] =
                                        newItemConfirmedCard;
                                      // xét phần tử mới vào mảng

                                      const itemFormat = formatItem({
                                        ...item,
                                        customerConfirmedPrepaidCards:
                                          currCustomerConfirmedCards,
                                      });
                                      await handleSaveItemAdvise(itemFormat);
                                    }}
                                  />
                                </>
                              </>
                            )
                          )}
                        </div>
                      </>
                    </Tooltip>
                  </div>
                </>
              )}

              {!(isInterestedTreatmentCards && isConfirmedTreatmentCards) && (
                <>
                  <div className="service-groups">
                    <Tooltip title="Liệu trình quan tâm">
                      <div
                        className={`service-group interested ${
                          isInterestedTreatmentCards && "unvisible"
                        }`}
                      >
                        {!isInterestedTreatmentCards && (
                          <div class="group-title">
                            <span class="tag tag-qt">LT</span>
                            <span class="title-text">Quan tâm</span>
                          </div>
                        )}
                        {item?.customerInterestedTreatmentCards?.map(
                          (el, index) => (
                            <div className="service-item" key={index}>
                              {`${index + 1}. ${
                                el?.clientCard?.name || el?.name
                              } - ${el?.clientCard?.code || el?.code}`}
                            </div>
                          )
                        )}
                      </div>
                    </Tooltip>
                    <Tooltip title="Liệu trình đã chốt">
                      <>
                        <div
                          className={`service-group confirmed ${
                            isConfirmedTreatmentCards && "unvisible"
                          }`}
                        >
                          {!isConfirmedTreatmentCards && (
                            <div class="group-title">
                              <span class="tag tag-dc">LT</span>
                              <span class="title-text">Đã chốt</span>
                            </div>
                          )}

                          {item?.customerConfirmedTreatmentCards?.map(
                            (el, ind) => (
                              <>
                                <div className="service-item" key={ind}>
                                  {`${ind + 1}. ${
                                    el?.clientCard?.name || el?.name
                                  } - ${el?.clientCard?.code || el?.code}`}
                                </div>

                                <>
                                  <SuggestionPrice
                                    suggestedPrice={
                                      el?.clientCard?.clientCardFees
                                    }
                                    nameSpace={`patientAdvice.items[${originalIndex}].customerConfirmedTreatmentCardsPrice[${ind}]`}
                                    patientTypeServiceSelected={
                                      el?.patientTypeService
                                    }
                                    onSelect={async (suggest) => {
                                      let newItemConfirmedCard = {
                                        ...el,
                                        patientTypeService:
                                          suggest?.patientTypeService,
                                        price: suggest?.price,
                                      }; // phần tử mới

                                      let currCustomerConfirmedTreatmentCards =
                                        [
                                          ...item?.customerConfirmedTreatmentCards,
                                        ];

                                      currCustomerConfirmedTreatmentCards[ind] =
                                        newItemConfirmedCard;
                                      // xét phần tử mới vào mảng

                                      const itemFormat = formatItem({
                                        ...item,
                                        customerConfirmedTreatmentCards:
                                          currCustomerConfirmedTreatmentCards,
                                      });
                                      await handleSaveItemAdvise(itemFormat);
                                    }}
                                    handleBlurPrice={async (price) => {
                                      let newItemConfirmedCard = {
                                        ...el,
                                        price,
                                      }; // phần tử mới

                                      let currCustomerConfirmedTreatmentCards =
                                        [
                                          ...item?.customerConfirmedTreatmentCards,
                                        ];

                                      currCustomerConfirmedTreatmentCards[ind] =
                                        newItemConfirmedCard;
                                      // xét phần tử mới vào mảng

                                      const itemFormat = formatItem({
                                        ...item,
                                        customerConfirmedTreatmentCards:
                                          currCustomerConfirmedTreatmentCards,
                                      });
                                      await handleSaveItemAdvise(itemFormat);
                                    }}
                                  />
                                </>
                              </>
                            )
                          )}
                        </div>
                      </>
                    </Tooltip>
                  </div>
                </>
              )}
              <div className="message-separator"></div>
            </>
          );
        })}
    </>
  );
};

export default memo(observer(ChatBoxAdviseContent));
